// extracted by extract-css-chunks-webpack-plugin
module.exports = {"imageProdBlock":"ertgq","verticalImageProdBlock":"rusLR","imageSlider":"i9FjE"};